module.exports = __webpack_public_path__ + "img/premium_01.fd9fec9c.jpg";